import { useEffect, useState } from "react";
import axios from "../../axios";
import AdminSidebar from "../components/AdminSidebar";
import AdminNavbar from "../components/AdminNavbar";
import { STORAGE_URL } from "../../constants";

export default function AdminTemplate({ children }) {
    const [setting, setSetting] = useState(null);

    useEffect(() => {
        const scripts = [
            "jquery-3.7.1.min.js",

            "boostrap.bundle.min.js",
            "phosphor-icon.js",
            "file-upload.js",
            "plyr.js",
            // "https://cdn.datatables.net/2.0.8/js/dataTables.min.js",
            "full-calendar.js",
            "jquery-ui.js",
            "editor-quill.js",
            // "apexcharts.min.js",
            // "calendar.js",
            "jquery-jvectormap-2.0.5.min.js",
            // "jquery-jvectormap-world-mill-en.js",
            "main.js",

        ];

        // Tambahkan script satu per satu dengan async: false
        const scriptTags = [];
        scripts.forEach((src) => {
            const script = document.createElement("script");
            script.src = `/admin-template/js/${src}`;
            script.async = false; // Penting agar urutan terjaga!
            document.body.appendChild(script);
            scriptTags.push(script);
        });

        return () => {
            scriptTags.forEach((script) => {
                if (document.body.contains(script)) document.body.removeChild(script);
            });
        };
    }, []);

    useEffect(() => {
        axios.get("/settings").then((res) => setSetting(res.data));
    }, []);

    return (
        <>
            <link rel="stylesheet" href="/admin-template/css/bootstrap.min.css" />
            <link rel="stylesheet" href="/admin-template/css/file-upload.css" />
            <link rel="stylesheet" href="/admin-template/css/plyr.css" />
            <link rel="stylesheet" href="/admin-template/css/full-calendar.css" />
            <link rel="stylesheet" href="/admin-template/css/jquery-ui.css" />
            <link rel="stylesheet" href="/admin-template/css/editor-quill.css" />
            {/* <link rel="stylesheet" href="/admin-template/css/apexcharts.css" /> */}
            <link rel="stylesheet" href="/admin-template/css/jquery-jvectormap-2.0.5.css" />
            <link rel="stylesheet" href="/admin-template/css/jquery-jvectormap-world-mill.css" />
            <link rel="stylesheet" href="/admin-template/css/main.css" />
            
            <link rel="icon" href={`${STORAGE_URL}${setting?.favicon}`} type="image/x-icon" />
            <title>{setting?.site_name || "Admin Dashboard"}</title>

            <div className="dashboard-main-wrapper">
                <AdminSidebar />
                <div className="top-navbar flex-between gap-16">
                    <div className="flex-align gap-16">
                        <button type="button" className="toggle-btn d-xl-none d-flex text-26 text-gray-500"><i className="ph ph-list"></i></button>

                        <form action="#" className="w-350 d-sm-block d-none">
                            <div className="position-relative">
                                <button type="submit" className="input-icon text-xl d-flex text-gray-100 pointer-event-none"><i className="ph ph-magnifying-glass"></i></button>
                                <input type="text" className="form-control ps-40 h-40 border-transparent focus-border-main-600 bg-main-50 rounded-pill placeholder-15" placeholder="Search..." />
                            </div>
                        </form>
                    </div>
                    <div className="flex-align gap-16">
                        <AdminNavbar />
                    </div>

                </div>

                <div className="dashboard-body">
                    <div className="container-fluid">
                        {children}
                    </div>
                </div>

                <div className="dashboard-footer text-start py-4">
                    <div className="container text-start">
                        {setting?.logo && (
                            <img src={`${STORAGE_URL}${setting.logo}`} width={50} alt="Logo" />
                        )}
                        <h5 className="mt-2">{setting?.site_name}</h5>
                        <p>{setting?.address}</p>
                        <p>Telepon: {setting?.phone}</p>

                        <div className="d-flex justify-content-center gap-3 mt-3">
                            {setting?.instagram && (
                                <a href={setting.instagram} target="_blank" rel="noreferrer">
                                    <i class="ph ph-instagram-logo" style={{fontSize:24}}></i>
                                </a>
                            )}
                            {setting?.tiktok && (
                                <a href={setting.tiktok} target="_blank" rel="noreferrer">
                                    <i class="ph ph-tiktok-logo" style={{fontSize:24}}></i>
                                </a>
                            )}
                            {setting?.facebook && (
                                <a href={setting.facebook} target="_blank" rel="noreferrer">
                                    <i class="ph ph-facebook-logo" style={{fontSize:24}}></i>
                                </a>
                            )}
                            {setting?.shopee && (
                                <a href={setting.shopee} target="_blank" rel="noreferrer">
                                    <img alt="" src="/icons/shopee.svg" width={24} />
                                </a>
                            )}
                            {setting?.tokopedia && (
                                <a href={setting.tokopedia} target="_blank" rel="noreferrer">
                                    <img alt="" src="/icons/tokopedia.svg" width={24} />
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
